import { Link } from "react-router-dom";

export default function AnnouncementBar() {
  return (
    <Link to="/shop" data-testid="announcement-bar" className="block bg-plum text-center">
      <p className="px-4 py-2 font-mono text-[10px] uppercase tracking-[0.28em] text-gold sm:text-[11px]">
        DROP 001 + DROP 002 — AVAILABLE NOW
        <span className="mx-2.5 inline-block h-1.5 w-1.5 rotate-45 bg-gold/70 align-middle" aria-hidden="true" />
        SHIPPING ACROSS INDIA
      </p>
    </Link>
  );
}
